<table>
    <tr>
        <th scope="col"><span class="visually-hidden">Feature</span></th>
        <th scope="col">Luxe</th>
        <th scope="col">Standard</th>
        <th scope="col">Notes</th>
    </tr>
    <tr>
        <th scope="row">Gloss Finish Option</th>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td></td>
    </tr>
    <tr>
        <th scope="row">Premium White Option</th>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td></td>
    </tr>
    <tr>
        <th scope="row">Food-Safe</th>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td><img src="assets/cb/images/icon_x-mark.svg" alt="Not included"></td>
        <td>Meets guidelines for both primary & seconday packaging</td>
    </tr>
    <tr>
        <th scope="row">Small Text Printing</th>
        <td>4 point</td>
        <td>10 point</td>
        <td>This is the smallest the text can go before blurring</td>
    </tr>
    <tr>
        <th scope="row">Odorless</th>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td><img src="assets/cb/images/icon_x-mark.svg" alt="Not included"></td>
        <td></td>
    </tr>
    <tr>
        <th scope="row">Water-Based Ink</th>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td><img src="assets/cb/images/icon_x-mark.svg" alt="Not included"></td>
        <td>CompanyBox proudly uses HP true Water-Based Inks</td>
    </tr>
    <tr>
        <th scope="row">High Resolution Printing</th>
        <td>600 dpi</td>
        <td>300 dpi</td>
        <td></td>
    </tr>
    <tr>
        <th scope="row">Perfect Skin Tone</th>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td><img src="assets/cb/images/icon_x-mark.svg" alt="Not included"></td>
        <td></td>
    </tr>
    <tr>
        <th scope="row">True Litho Replacement</th>
        <td><img src="assets/cb/images/icon_checkmark.svg" alt="Included"></td>
        <td><img src="assets/cb/images/icon_x-mark.svg" alt="Not included"></td>
        <td>Replicates that quality of Lithographic printing without the cost</td>
    </tr>

</table>
